export const WEBHOOKS_KEY = 'webhooks';
export const WEBHOOK_KEY = 'webhook';

export const WEBHOOKS_NOTIFICATIONS_KEY = 'notification_bindings';
export const NOTIFICATION_KINDS_KEY = 'notification_kinds';
export const WEBHOOK_HEADERS = 'webhook_headers';
